import { Charts } from './Charts';
import TradicionalGroupsChartsDataProvider from './contexts/TradicionalGroupsChartsDataContext';

const TradicionalGroupsWrapper = () => {
    return (
        <TradicionalGroupsChartsDataProvider>
            <Charts />
        </TradicionalGroupsChartsDataProvider>
    );
};

export default TradicionalGroupsWrapper;
